import { Button, Col, Container, Form, Row } from "react-bootstrap";
import cn from "classnames";
import Search from "@/assets/Search.svg";
import styles from "./styles.module.scss";
import { useCallback, useState } from "react";
import { speciality_helper } from "@/helpers/speciality_helper";
import { getRoute } from "@/functions/getRoute";
import { job_type_helper } from "@/helpers/job_type_helper";
import { salary_helper } from "@/helpers/salary_helper";
import { grade_helper } from "@/helpers/grade_helper";

export const QuickJobSearch = ({ className, stack }) => {
  const [specialities] = useState(speciality_helper.fetch());
  const [job_types] = useState(job_type_helper.fetch());
  const [salaries] = useState(salary_helper.fetch());
  const [grades] = useState(grade_helper.fetch());

  const [query, setQuery] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [grade, setGrade] = useState("");
  const [location, setLocation] = useState("");
  const [job_type, setJobType] = useState([]);
  const [salary, setSalary] = useState("");
  const [radius, setRadius] = useState("");

  const handleSubmit = useCallback(() => {
    const params = new URLSearchParams({
      query,
      location,
      radius,
    });

    let urlFilters = [];
    let url = `${getRoute("jobs")}?${params.toString()}`;

    if (speciality) {
      urlFilters = [...urlFilters, speciality];
    }

    if (grade) {
      urlFilters = [...urlFilters, grade];
    }

    if (job_type) {
      urlFilters = [...urlFilters, ...job_type];
    }

    if (salary) {
      urlFilters = [...urlFilters, ...salary];
    }

    if (urlFilters.length > 0) {
      url = `${url}#/${urlFilters.join("/")}`;
    }

    window.location.href = `${url}/`.toLowerCase();
  }, [query, location, radius, speciality, grade, job_type, salary]);

  return (
    <div className={cn(className, styles.search)}>
      <Container className="p-0">
        <Form className={cn(styles.search__form)} onSubmit={handleSubmit}>
          <div className="p-4">
            {!stack && <h3 className="mb-3">Find your next job</h3>}
            <Row>
              <Col xs={12} md={stack ? 12 : 3} className="mb-2">
                <Form.Group>
                  <Form.Label>Job Title / keywords</Form.Label>
                  <Form.Control placeholder="Doctor" value={query} onChange={(e) => setQuery(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={12} md={stack ? 12 : 3} className="mb-2">
                <Form.Group>
                  <Form.Label>Speciality</Form.Label>
                  <Form.Select value={speciality} onChange={(e) => setSpeciality(e.target.value)}>
                    <option key="none" value="">
                      Select
                    </option>
                    {specialities.map(({ title }) => (
                      <option key={title} value={title}>
                        {title}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={stack ? 12 : 3} className="mb-2">
                <Form.Group>
                  <Form.Label>Grade</Form.Label>
                  <Form.Select value={grade} onChange={(e) => setGrade(e.target.value)}>
                    <option key="none" value="">
                      Select
                    </option>
                    {grades.map(({ title }) => (
                      <option key={title} value={title}>
                        {title}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={stack ? 12 : 3} className="mb-2">
                <Form.Group>
                  <Form.Label>Location / Postcode</Form.Label>
                  <Form.Control placeholder="Sydney" value={location} onChange={(e) => setLocation(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={12} md={stack ? 12 : 3} className="mb-2">
                <Form.Group>
                  <Form.Label>Job type</Form.Label>
                  {job_types.map(({ title }) => (
                    <Form.Check
                      key={title}
                      value={title}
                      label={title}
                      onChange={(e) => {
                        setJobType(e.target.checked ? [...job_type, title] : job_type.filter((i) => i !== title));
                      }}
                    />
                  ))}
                </Form.Group>
              </Col>
              {!stack && (
                <>
                  <Col xs={6} md={2} className="mb-2">
                    <Form.Group>
                      <Form.Label>Salary</Form.Label>
                      <Form.Select value={salary} onChange={(e) => setSalary(e.target.value)}>
                        <option key="none" value="">
                          Select
                        </option>
                        {salaries.map(({ title }) => (
                          <option key={title} value={title}>
                            {title}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={2} className="mb-3">
                    <Form.Group>
                      <Form.Label>Within</Form.Label>
                      <Form.Select value={radius} onChange={(e) => setRadius(e.target.value)}>
                        <option value="5">5 miles</option>
                        <option value="10">10 miles</option>
                        <option value="20">20 miles</option>
                        <option value="30">30 miles</option>
                        <option value="40">40 miles</option>
                        <option value="50">50 miles</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={2} />
                </>
              )}
              <Col xs={12} md={stack ? 12 : 3}>
                <Form.Label className="opacity-0">Submit</Form.Label>
                <Button variant="tertiary" className="w-100" onClick={handleSubmit}>
                  Search
                  <Search />
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default QuickJobSearch;